import { FC, useContext, useCallback } from 'react';
import { observer } from "mobx-react-lite";
import { AppContext } from "../../../App";
import "./btnAdd.css"

import { ReactComponent as AddElement } from "../../../assets/images/addDefault.svg";

export interface IAddButtonProps {
    onClickFunc: (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent) => void;
    type: string;
    permission: boolean | undefined;
}

const BtnAdd: FC<IAddButtonProps> = observer(({ onClickFunc, type, permission }) => {
    const { showToast } = useContext(AppContext);

    const handleFileClick = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (permission) {
            onClickFunc(e);
        }
    }, [permission, onClickFunc]);

    const handleButtonClick = useCallback((e: React.MouseEvent) => {
        // if (permission) {
        onClickFunc(e);
        // } else {
        //     showToast("У вас нет прав для добавления файла!");
        // }
    }, [onClickFunc]);

    const disabledStyle = { backgroundColor: "#75848a49" };
    const buttonStyle = permission ? {} : disabledStyle;

    if (type === 'file') {
        return (
            <label className="input-file margin_btn">
                {permission && (
                    <input
                        onChange={handleFileClick}
                        type="file"
                        style={{ display: 'none' }}
                    />
                )}
                <span
                    onClick={() => !permission && showToast("У вас нет прав для добавления файла!")}
                    className="input-file-btn"
                    style={buttonStyle}
                >
                    <AddElement 
                        className='add-button-svg'
                    />
                </span>
            </label>
        );
    }

    return (
        <div
            className="button_add margin_btn"
            style={buttonStyle}
            onClick={handleButtonClick}
        >
            <AddElement 
                className='add-button-svg'
            />
        </div>
    );
});

export default BtnAdd;